module.exports = __webpack_public_path__ + "img/picture-water-desktop-mobile.c0df6fe3.jpg";